function init(scope) {
  const profiles = scope.querySelectorAll('[data-nosely-profile]:not([data-profile-ready])');
  if (!profiles.length || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      target.classList.toggle('is-in-view', isIntersecting);
      if (!isIntersecting) return;
      target.classList.remove('is-pending');
      target.classList.add('is-revealed');
    });
  }, { threshold:0.15 });
  profiles.forEach(profile => {
    profile.dataset.profileReady = '';
    profile.classList.add('is-pending');
    observer.observe(profile);
  });
  const unload = event => {
    if (![...profiles].some(profile => event.target.contains(profile))) return;
    observer.disconnect();
    document.removeEventListener('shopify:section:unload', unload);
  };
  if (profiles.length) document.addEventListener('shopify:section:unload', unload);
}
init(document);
document.addEventListener('shopify:section:load', event => init(event.target));
